require('./RASetGoalView.scss');
require('./RASetGoalView.override.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const moment = require('moment');

// @commons
const RACover = require('../../components/commons/RACover/RACover');
const RAFooter = require('../../components/commons/RAFooter/RAFooter');
const RACommissionCondition = require('../../components/RACommissionCondition/RACommissionCondition');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const RASetGoalStep1 = require('../../components/RASetGoal/RASetGoalStep1/RASetGoalStep1');
const RASetGoalStep2 = require('../../components/RASetGoal/RASetGoalStep2/RASetGoalStep2');
const RANonresidentialModal = require('../../components/RANonresidentialModal/RANonresidentialModal');
const RASaveSimulationModal = require('../../components/RASaveSimulationModal/RASaveSimulationModal');
const RATimeHorizonCheck = require('../../components/RATimeHorizonCheck/RATimeHorizonCheck');
const RAFeatureFlagModal = require('../../components/RAFeatureFlagModal/RAFeatureFlagModal');
const RAEmailRequiredWarning = require('../../components/contactCenter/RAEmailRequiredWarning/RAEmailRequiredWarning');
const PersonalDataHelper = require('utilities/personalDataHelper');
const OKModal = require('components/commons/OKModal/OKModal');

// @actions
const RACustomPlanByObjectiveActions = require('../../actions/RACustomPlanByObjective');
const RAFeatureFlagActions = require('../../actions/RAFeatureFlag');
const RASetGoalActions = require('../../actions/RASetGoal');
const RASimulationActions = require('../../actions/RASimulation');
const RASuitabilityTestActions = require('../../actions/RASuitabilityTest');
const RATimeHorizonCheckActions = require('../../actions/RATimeHorizonCheck');
const raHireManagementPlanActions = require('../../actions/RAHireManagementPlan');
const raCustomPlanByObjectiveActions = require('../../actions/RACustomPlanByObjective');
const raPortfoliosNameHistoryActions = require('../../actions/RAPortfoliosNameHistory');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { recordLink, recordLinkV2 } = require('utilities/tagging');
const { isTestValid } = require('../../utilities/RASuitabilityTestHelper');

// @constants
const { FIRST_STEP, SECOND_STEP, DATE_FORMAT_API } = require('constants/index');
const {
    MYPROFILE_BROKER_ROBO_URL,
    RA_NON_RESIDENTIAL_MODEL_CONTACT_NUMBER,
    DATE_FORMAT_TIME_HORIZON_CHECK,
    TIME_HORIZON_CHECK_ERROR,
    RA_NO_STRATEGY_SELECTED,
    SUITABILITY_TEST_URL,
    MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    MYPROFILE_ROBO_SETGOAL,
} = require('../../raConstants/index');
const {
    ROBO_ZERO_COMMISSION,
    SUITABILITY_HIRE_MAINTENANCE_POPUP,
} = require('constants/flagBasedFeatures');

class RASetGoalView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            errorFlag: false,
            openModalMaintenance: false,
        };

        this.handleDatePickerError = this.handleDatePickerError.bind(this);
        this.handleDeleteSimulation = this.handleDeleteSimulation.bind(this);
        this.handleGoalSetter = this.handleGoalSetter.bind(this);
        this.handleInvestmentAmountChange = this.handleInvestmentAmountChange.bind(
            this,
        );
        this.handleInvestmentDateChange = this.handleInvestmentDateChange.bind(
            this,
        );
        this.handleInvestmentTitleChange = this.handleInvestmentTitleChange.bind(
            this,
        );
        this.handleOnFinish = this.handleOnFinish.bind(this);
        this.handleResetGoal = this.handleResetGoal.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.buildGoalSettingSection = this.buildGoalSettingSection.bind(this);
        this.shortStrategyNumber = this.shortStrategyNumber.bind(this);
        this.handleValidateTimeHorizonCheck = this.handleValidateTimeHorizonCheck.bind(
            this,
        );
        this.handleSaveModelClose = this.handleSaveModelClose.bind(this);
        this.handleCloseModalMaintenance = this.handleCloseModalMaintenance.bind(
            this,
        );
    }

    componentWillMount() {
        const { getTestResult, requestSimulation } = this.props;
        getTestResult();
        requestSimulation(false, this.props.getSimulation);
    }

    componentDidMount() {
        const {
            fetchFeatureFlag,
            immProfile,
            validateResidentiality,
            immSaveSimulation,
            saveSimulationChangeModalOption,
            getDisplayNames,
            immFlagBasedFeatures,
        } = this.props;
        validateResidentiality(immProfile, 'objectivo');
        fetchFeatureFlag();
        getDisplayNames();
        const objectiveName = immSaveSimulation.getIn([
            'saveSimulationObjective',
            'name',
        ]);
        const email = PersonalDataHelper.getEmail(immProfile);
        if (!!objectiveName && objectiveName.length > 0) {
            !(!email && __CONTACT_CENTER__) &&
                saveSimulationChangeModalOption(true); //email warning model will be shown only
        }

        const isHireMaintenancePopup = immFlagBasedFeatures.get(
            SUITABILITY_HIRE_MAINTENANCE_POPUP,
        );
        if (isHireMaintenancePopup) {
            this.setState({
                openModalMaintenance: true,
            });
            recordLinkV2({
                action: 'open',
                format: 'modal',
                component: 'modal/technicalUpdateDeferOperations',
                element: 'full',
                eventCategory: 'robo-advisor/set-goal',
                eventAction: 'technicalUpdateDeferOperations',
                eventLabel: 'full',
            });
        }
    }

    componentDidUpdate(prevProps) {
        const {
            immProfile,
            featureModalToggle,
            immSetGoal,
            immRAFeatureFlag,
            match: {
                params: { goalType },
            },
        } = this.props;
        const immprevRAFeatureFlag = prevProps.immRAFeatureFlag;
        const isFetching =
            immRAFeatureFlag.get('isFetching') !==
            immprevRAFeatureFlag.get('isFetching');
        const purchaseFlag =
            immRAFeatureFlag.get('purchase') !==
            immprevRAFeatureFlag.get('purchase');
        const prevInvestmentDate = prevProps.immSetGoal.getIn([
            'steps',
            SECOND_STEP,
            'investmentDate',
        ]);
        const investmentDate = immSetGoal.getIn([
            'steps',
            SECOND_STEP,
            'investmentDate',
        ]);
        const investmentDateUpdated =
            investmentDate && !investmentDate.isSame(prevInvestmentDate);
        const email = PersonalDataHelper.getEmail(immProfile);

        if (isFetching && purchaseFlag) {
            if (!immRAFeatureFlag.get('purchase')) {
                !(!email && __CONTACT_CENTER__) && featureModalToggle(); //email warning model will be shown only
            }
        }
        if (
            goalType &&
            immSetGoal.getIn(['steps', SECOND_STEP, 'getSimulationSucceed'])
        ) {
            this.props.updateGoalSelected({ id: goalType });
        }

        //Checking timeHorizonCheck only when simulation is fetched and date has changed. Also getting dispatched on calendar handler, this avoids trigger on reset.
        const simulationIsFetched =
            this.props.immSimulation.get('success') &&
            !prevProps.immSimulation.get('success');
        if (investmentDateUpdated && simulationIsFetched) {
            this.props.timeHorizonCheck(
                () => {},
                () => {},
            );
        }

        if ((investmentDate === null) & (prevInvestmentDate !== null)) {
            this.props.resetMaxTypeOfProduct();
        }
    }

    componentWillUnmount() {
        this.props.resetStep();
        this.props.resetCustomPlanByObjective();
        this.props.resetMaxTypeOfProduct();
    }

    handleOnFinish() {
        this.props.saveGoal(() => {
            this.props.history.push(
                `/myprofile/robo/goal/customPlanByObjective`,
            );
        });
    }

    handleToggleModal() {
        this.props.closeNonresidentialModal();
        this.props.history.push(MYPROFILE_BROKER_ROBO_URL);
    }

    shortStrategyNumber() {
        const { immTimeHorizonCheck, immCustomPlanByObjective } = this.props;
        const maxTypeOfProduct = immTimeHorizonCheck.get('maxTypeOfProduct');
        const selectedStrategy = immCustomPlanByObjective.get(
            'selectedStrategy',
        );

        if (
            maxTypeOfProduct < selectedStrategy &&
            selectedStrategy !== RA_NO_STRATEGY_SELECTED
        ) {
            this.props.setSelectedStrategy(RA_NO_STRATEGY_SELECTED);
        }
    }

    handleValidateTimeHorizonCheck() {
        const { immCheckStatus, immSetGoal } = this.props;
        const selectedObjective = immSetGoal.getIn([
            'steps',
            FIRST_STEP,
            'goalTypeSelected',
        ]);
        const selectedEndDate = immSetGoal.getIn([
            'steps',
            SECOND_STEP,
            'investmentDate',
        ]);
        const eventTag =
            selectedObjective +
            ' ' +
            moment(selectedEndDate).format(DATE_FORMAT_API);

        recordLink(
            'configura tu objetivo',
            'confirmar configuracion',
            eventTag,
        );

        if (!isTestValid(immCheckStatus)) {
            this.props.saveGoal(() => {
                this.props.setFromSetGoal();
                this.props.history.push(SUITABILITY_TEST_URL);
            });
        } else {
            this.props.timeHorizonCheck(
                this.handleOnFinish,
                this.shortStrategyNumber,
            );
        }
    }

    getBreadcrumb() {
        return [
            {
                text: formatText('raSetGoal-investments'),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            {
                text: formatText('raSetGoal-headerTitle'),
            },
        ];
    }

    handleInvestmentAmountChange(value) {
        this.props.setInvestmentGoalValue('investmentAmount', value);
    }

    handleInvestmentDateChange(value) {
        this.props.setInvestmentGoalValue('investmentDate', value);
        this.props.setTimeHorizonCheck(
            value.format(DATE_FORMAT_TIME_HORIZON_CHECK),
        );
        if (!!value) {
            this.props.timeHorizonCheck(
                () => {},
                () => {},
            );
        }
    }

    handleInvestmentTitleChange(event) {
        this.props.setInvestmentGoalValue('investmentTitle', event);
    }

    handleDatePickerError() {
        const { immSetGoal } = this.props;
        if (!immSetGoal.getIn(['steps', SECOND_STEP, 'dateError'])) {
            this.props.setDateError();
        }
    }

    handleGoalSetter(goal) {
        const { updateGoalSelected } = this.props;
        updateGoalSelected(goal);
    }

    handleResetGoal() {
        this.props.resetMaxTypeOfProduct();
        this.props.resetStep();
    }
    handleDeleteSimulation() {
        this.props.resetMaxTypeOfProduct();
        this.props.resetValueOfSaveSimulation();
    }

    isStep2Valid() {
        const { immSetGoal, immTimeHorizonCheck } = this.props;
        const immStep = immSetGoal.getIn(['steps', SECOND_STEP]);
        return (
            immStep.get('investmentAmount') >= 500 &&
            immStep.get('investmentTitle') !== '' &&
            !!immStep.get('investmentDate') &&
            immTimeHorizonCheck.get('status') !== TIME_HORIZON_CHECK_ERROR &&
            !immStep.get('dateError')
        );
    }

    buildGoalSettingSection() {
        const { immSetGoal, immPortfoliosNameHistory } = this.props;
        const namesHistory = immPortfoliosNameHistory.get('namesHistory');
        const isFirstStepActive = immSetGoal.get('visibleStep') === FIRST_STEP;
        const step2Valid = this.isStep2Valid();
        const goalSelected = immSetGoal.getIn([
            'steps',
            FIRST_STEP,
            'goalSelected',
        ]);
        const immStep = immSetGoal.getIn(['steps', SECOND_STEP]);
        const injectedStrings = [MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT];
        return (
            <div className="row ra-set-goal-view__wizard-section">
                <div className="col-xs-12 ra-set-goal-view__wizard">
                    <RASetGoalStep1
                        active={isFirstStepActive}
                        immSteps={immSetGoal.get('steps')}
                        resetStep={this.handleResetGoal} // eslint-disable-line
                        updateGoalSelected={this.handleGoalSetter} // eslint-disable-line
                    />
                    <RASetGoalStep2
                        isValid={step2Valid}
                        immSteps={immSetGoal.get('steps')}
                        onInvestmentAmountChange={
                            this.handleInvestmentAmountChange
                        }
                        onDateChange={this.handleInvestmentDateChange}
                        onDatePickerError={this.handleDatePickerError}
                        onTitleChange={this.handleInvestmentTitleChange}
                        disabled={goalSelected}
                        namesHistory={namesHistory}
                        errorState={immStep.get('errorFlags')}
                        errorMsg={formatText(
                            'rainput-amoutInputMinimumValidation',
                            injectedStrings,
                        )}
                    />
                    <RATimeHorizonCheck />
                </div>
            </div>
        );
    }

    shouldDisableFinishButton(immSetGoal) {
        return !(
            immSetGoal.getIn(['steps', FIRST_STEP, 'goalSelected']) &&
            this.isStep2Valid()
        );
    }

    shouldRenderLoading() {
        const { immSuitabilityTest, immSimulation } = this.props;

        return (
            immSuitabilityTest.get('isFetchingResults') ||
            immSimulation.get('isFetching')
        );
    }

    buildFeatureModal() {
        const { immRAFeatureFlag, featureModalToggle } = this.props;
        return (
            <RAFeatureFlagModal
                immRAFeatureFlag={immRAFeatureFlag}
                featureModalToggle={featureModalToggle}
                redirectionLink={MYPROFILE_BROKER_ROBO_URL}
            />
        );
    }

    handleSaveModelClose() {
        this.props.saveSimulationChangeModalOption(false);
    }

    buildSaveSimulationModal() {
        return (
            <RASaveSimulationModal
                link={MYPROFILE_ROBO_SETGOAL}
                isModalOpen={this.props.immCustomPlanByObjective.get(
                    'isSaveSimulationModalOpen',
                )}
                onModalClose={this.handleSaveModelClose}
                deleteSimulation={this.props.deleteSimulation}
                immSimulation={this.props.immSimulation}
                immSaveSimulation={this.props.immSaveSimulation}
                resetValueOfSaveSimulation={this.handleDeleteSimulation} // eslint-disable-line
                isObjective={true}
            />
        );
    }

    handleCloseModalMaintenance() {
        recordLinkV2({
            action: 'click',
            format: 'button',
            component: 'modal/technicalUpdateDeferOperations',
            element: 'understood',
            eventCategory: 'robo-advisor/set-goal',
            eventAction: 'technicalUpdateDeferOperations',
            eventLabel: 'understood',
        });
        this.setState({
            openModalMaintenance: false,
        });
    }

    render() {
        const {
            flagBasedFeatures,
            immCheckStatus,
            immCustomPlanByObjective,
            immManagementPlan,
            immSetGoal,
            immPortfoliosNameHistory,
            immProfile,
            immTimeHorizonCheck,
        } = this.props;
        const mappingBreadcrumb = this.getBreadcrumb();
        let content = this.buildGoalSettingSection();
        const namesHistory = immPortfoliosNameHistory.get('namesHistory');
        const objectiveTitle = immSetGoal.getIn([
            'steps',
            SECOND_STEP,
            'investmentTitle',
        ]);
        const objectiveNameError = namesHistory.some(
            names => names.toLowerCase() === objectiveTitle.toLowerCase(),
        );
        const displayNonResidentialModal = immSetGoal.get(
            'isNonresidentialModalOpen',
        );

        const disableFooterRightContent =
            objectiveNameError || this.shouldDisableFinishButton(immSetGoal);
        const loadingFinish = immTimeHorizonCheck.get('isFetching');
        const saveSimulationModal =
            !immManagementPlan.get('isEditClicked') &&
            immCustomPlanByObjective.get('isSaveSimulationModalOpen')
                ? this.buildSaveSimulationModal()
                : null;

        const featureModal = this.buildFeatureModal();
        const clientName = PersonalDataHelper.getFullName(immProfile, false);
        const email = PersonalDataHelper.getEmail(immProfile);

        let commisionCondition;
        if (
            flagBasedFeatures.get(ROBO_ZERO_COMMISSION) &&
            immCheckStatus.get('zeroCommission')
        ) {
            commisionCondition = (
                <div className="row ra-set-goal-view__conditions">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <RACommissionCondition />
                        </div>
                    </div>
                </div>
            );
        }

        if (this.shouldRenderLoading()) {
            return (
                <div className="ra-set-goal-view__loading-wrapper">
                    <LoadingSection />
                </div>
            );
        }

        const contentModal = (
            <div className="ra-set-goal-view__content-modal">
                <p>
                    <FormattedText value="raSetGoal-descriptionOneMaintenanceModal" />
                </p>
                <p>
                    <FormattedText value="raSetGoal-descriptionTwoMaintenanceModal" />
                </p>
            </div>
        );

        return (
            <div className="ra-set-goal-view grid-view">
                <OKModal
                    content={contentModal}
                    isOpen={this.state.openModalMaintenance}
                    onCloseCallback={this.handleCloseModalMaintenance}
                    onPrimaryButtonClick={this.handleCloseModalMaintenance}
                    primaryButtonText="raSetGoal-maintenancePrimaryButton"
                    shouldCloseOnOverlayClick={false}
                    size="small"
                    descriptionAlignment="center"
                    title="raSetGoal-titleMaintenanceModal"
                    titleAlignment="center"
                    footerType="action"
                />
                {saveSimulationModal}
                <RANonresidentialModal
                    showModal={displayNonResidentialModal}
                    title={formatText('raNonresidentialModal-titleObjective')}
                    closeModal={this.handleToggleModal} // eslint-disable-line
                    message={formatText('raNonresidentialModal-description')}
                    button={formatText('raNonresidentialModal-button')}
                    number={RA_NON_RESIDENTIAL_MODEL_CONTACT_NUMBER}
                />
                <RAEmailRequiredWarning email={email} clientName={clientName} />
                <div className="container-fluid">
                    <div className="row">
                        <RACover
                            breadcrumb={mappingBreadcrumb}
                            section="goal"
                            showHelp={false}
                            title={formatText('raSetGoal-headerTitle')}
                        />
                    </div>
                </div>
                <div className="row ra-set-goal-view__container">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            {content}
                            {featureModal}
                        </div>
                    </div>
                </div>
                {commisionCondition}
                <div className="row ra-set-goal-view__footer">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <RAFooter
                                cancelPath={MYPROFILE_BROKER_ROBO_URL}
                                disableRightButton={disableFooterRightContent}
                                loading={loadingFinish}
                                rightButtonText={formatText(
                                    'raSetGoal-ctaConfirm',
                                )}
                                showRightContent={true}
                                onRightButtonClick={
                                    this.handleValidateTimeHorizonCheck
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RASetGoalView.propTypes = {
    deleteSimulation: PropTypes.func.isRequired,
    fetchFeatureFlag: PropTypes.func.isRequired,
    featureModalToggle: PropTypes.func.isRequired,
    immCheckStatus: PropTypes.object.isRequired,
    immCustomPlanByObjective: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immManagementPlan: PropTypes.object.isRequired,
    immRAFeatureFlag: PropTypes.object.isRequired,
    immSetGoal: PropTypes.object.isRequired,
    immSaveSimulation: PropTypes.object.isRequired,
    immSimulation: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
    immTimeHorizonCheck: PropTypes.object.isRequired,
    getDisplayNames: PropTypes.func.isRequired,
    getSimulation: PropTypes.func.isRequired,
    getTestResult: PropTypes.func.isRequired,
    match: PropTypes.object,
    timeHorizonCheck: PropTypes.func.isRequired,
    resetMaxTypeOfProduct: PropTypes.func.isRequired,
    requestSimulation: PropTypes.func.isRequired,
    resetCustomPlanByObjective: PropTypes.func.isRequired,
    resetStep: PropTypes.func.isRequired,
    resetValueOfSaveSimulation: PropTypes.func.isRequired,
    saveGoal: PropTypes.func.isRequired,
    saveSimulationChangeModalOption: PropTypes.func.isRequired,
    setDateError: PropTypes.func.isRequired,
    setFromSetGoal: PropTypes.func.isRequired,
    setInvestmentGoalValue: PropTypes.func.isRequired,
    setSelectedStrategy: PropTypes.func.isRequired,
    setTimeHorizonCheck: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    updateGoalSelected: PropTypes.func,
    validateStep: PropTypes.func.isRequired,
    immPortfoliosNameHistory: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    validateResidentiality: PropTypes.func.isRequired,
    closeNonresidentialModal: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immManagementPlan: state.raManagementPlan,
        immRAFeatureFlag: state.raFeatureFlag,
        immSuitabilityTest: state.raSuitabilityTest,
        immSaveSimulation: state.raSaveSimulation,
        immSimulation: state.raSimulation,
        immCheckStatus: state.raCheckStatus,
        immSetGoal: state.raSetGoal,
        immPortfoliosNameHistory: state.raPortfoliosNameHistory,
        immProfile: state.profile,
        immTimeHorizonCheck: state.raTimeHorizonCheck,
        immCustomPlanByObjective: state.raCustomPlanByObjective,
        flagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        deleteSimulation: raHireManagementPlanActions.deleteSimulation,
        fetchFeatureFlag: RAFeatureFlagActions.fetchFeatureFlag,
        featureModalToggle: RAFeatureFlagActions.featureModalToggle,
        requestSimulation: RASimulationActions.requestSimulation,
        resetCustomPlanByObjective: RACustomPlanByObjectiveActions.reset,
        resetStep: RASetGoalActions.resetStep,
        resetValueOfSaveSimulation:
            RASimulationActions.resetObjectiveValueOfSaveSimulation,
        saveGoal: RASetGoalActions.saveGoal,
        saveSimulationChangeModalOption:
            raCustomPlanByObjectiveActions.saveSimulationChangeModalOption,
        getDisplayNames: raPortfoliosNameHistoryActions.getDisplayNames,
        getSimulation: RASetGoalActions.getSimulation,
        getTestResult: RASuitabilityTestActions.getTestResult,
        setDateError: RASetGoalActions.setDateError,
        setFromSetGoal: RASetGoalActions.setFromSetGoal,
        setInvestmentGoalValue: RASetGoalActions.setInvestmentGoalValue,
        setSelectedStrategy: RACustomPlanByObjectiveActions.setSelectedStrategy,
        setTimeHorizonCheck: RATimeHorizonCheckActions.setTimeHorizonCheck,
        setVisibleStep: RASetGoalActions.setVisibleStep,
        resetMaxTypeOfProduct: RATimeHorizonCheckActions.resetMaxTypeOfProduct,
        updateGoalSelected: RASetGoalActions.updateGoalSelected,
        validateStep: RASetGoalActions.validateStep,
        validateResidentiality: RASetGoalActions.validateResidentiality,
        closeNonresidentialModal: RASetGoalActions.closeNonresidentialModal,
        timeHorizonCheck: RATimeHorizonCheckActions.timeHorizonCheck,
    },
)(withRouter(RASetGoalView));
